import { createStyles } from '@zn-material-ui'

export default () =>
  createStyles({
    title: {
      top: '90px',
      left: '50%',
      color: '#363C46',
      position: 'absolute',
      fontSize: '30px',
      transform: 'translate(-50%)',
      textAlign: 'center',
      '&:lang(en)':{
        top: '25px',
      },
    },
    content: {
      color: '#363C46',
      width: '460px',
      height: '450px',
      margin: '60px 70px 20px 70px',
      overflow: 'auto',
      fontSize: '16px',
      lineHeight: 1.8,
    },
    foot: {
      marginTop: 20,
      textAlign: 'right',
    },
    agreeButtonWrapper: {
      justifyContent: 'center',
      display: 'flex',
    },
    agreeButton: {},
    edition: {
      textAlign: 'right',
    },
    mytable: {
      border: '#000 solid',
      borderWidth: '1px 0 0 1px',
    },
    mytd: {
      border: '#000 solid',
      borderWidth: '0 1px 1px 0',
    },
  })
